import React, { useState } from 'react';
import Drawer from 'components/commercetools-ui/atoms/drawer';
import { Link } from 'components/commercetools-ui/organisms/header/types';
import Slideout, { MenuState } from 'components/commercetools-ui/organisms/header/utility-section/components/slide-out';
import { useFormat } from 'helpers/hooks/useFormat';
import { useCart, useWishlist } from 'frontastic';
import { ImageProps } from 'frontastic/lib/image';
import AccountButton from './components/account-button';

export interface Props {
  emptyCartTitle?: string;
  emptyCartSubtitle?: string;
  emptyCartImage?: ImageProps;
  emptyCartCategories?: Link[];
  emptyWishlistTitle?: string;
  emptyWishlistSubtitle?: string;
  emptyWishlistImage?: ImageProps;
  emptyWishlistCategories?: Link[];
}

const UtilitySection: React.FC<Props> = ({
  emptyCartTitle,
  emptyCartSubtitle,
  emptyCartImage,
  emptyCartCategories,
  emptyWishlistTitle,
  emptyWishlistSubtitle,
  emptyWishlistImage,
  emptyWishlistCategories,
}) => {
  const { totalItems: totalCartItems } = useCart();
  const { totalItems: totalWishlistItems } = useWishlist();
  const { formatMessage: formatCartMessage } = useFormat({ name: 'cart' });
  const { formatMessage: formatWishlistMessage } = useFormat({ name: 'wishlist' });

  const [menuState, setMenuState] = useState<MenuState>();
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const onWishlistClicked = () => {
    setIsDrawerOpen(true);
    setMenuState('wishlist');
  };

  const onCartClicked = () => {
    setIsDrawerOpen(true);
    setMenuState('cart');
  };

  return (
    <div className="mt-12 flex h-40 items-center">
      <div className="flex justify-between gap-x-8 lg:gap-x-16">
        {/* <AccountButton /> */}

        {/* <div className="h-40 w-fit">
          <div
            title={formatWishlistMessage({ id: 'wishlist', defaultMessage: 'Wishlist' })}
            className="relative h-fit cursor-pointer border-secondary-black pb-8 flex flex-col items-center"
            onClick={onWishlistClicked}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M4.31802 6.31802C2.56066 8.07538 2.56066 10.9246 4.31802 12.682L12.0001 20.364L19.682 12.682C21.4393 10.9246 21.4393 8.07538 19.682 6.31802C17.9246 4.56066 15.0754 4.56066 13.318 6.31802L12.0001 7.63609L10.682 6.31802C8.92462 4.56066 6.07538 4.56066 4.31802 6.31802Z"
                 stroke="#666666" className="hover:fill-[#E5D3C7] hover:stroke-[#E5D3C7]" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span className='text-10 font-semibold text-[#666] hidden md:block'>Wishlist</span>
          </div>
        </div> */}

        {/* <div className="h-40 w-fit">
          <div
            title={formatCartMessage({ id: 'myCart', defaultMessage: 'My Cart' })}
            className="h-fit cursor-pointer border-secondary-black pb-8 hover:border-b-2"
            onClick={onCartClicked}
          >
            <CartIcon
              className="w-28 text-secondary-black"
              totalCartItems={totalCartItems}
              counterClassName="-translate-y-1/4"
            />
          </div>
        </div> */}
      </div>

      <Drawer
        isOpen={isDrawerOpen}
        direction="right"
        className="w-[90%] max-w-[380px] bg-white"
        onClose={() => setIsDrawerOpen(false)}
      >
        {/* <Slideout
          state={menuState}
          onClose={() => setIsDrawerOpen(false)}
          changeState={(newState) => setMenuState(newState)}
          emptyCartTitle={emptyCartTitle}
          emptyCartSubtitle={emptyCartSubtitle}
          emptyCartImage={emptyCartImage}
          emptyCartCategories={emptyCartCategories}
          emptyWishlistTitle={emptyWishlistTitle}
          emptyWishlistSubtitle={emptyWishlistSubtitle}
          emptyWishlistImage={emptyWishlistImage}
          emptyWishlistCategories={emptyWishlistCategories}
        /> */}
      </Drawer>
    </div>
  );
};

export default UtilitySection;